

export const monicaReviewerReviewHinge = {
  _id: 'monicaReviewerReviewHingeId',
  email: 'monica@email.com',
  profileReviewId: 'monicaProfileReviewHingeId',
  reviewerProfileId: 'monicaReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Monica! This will really help me!',
  profileReviewedFirstName: 'Rachel',
}

export const rossReviewerReviewBumble = {
  _id: 'rossReviewerReviewBumbleId',
  email: 'ross@email.com',
  profileReviewId: 'rossProfileReviewBumbleId',
  reviewerProfileId: 'rossReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Ross! This will really help me!',
  profileReviewedFirstName: 'Rachel',
}

export const joeyReviewerReviewTinder = {
  _id: 'joeyReviewerReviewTinderId',
  email: 'joey@email.com',
  profileReviewId: 'joeyProfileReviewTinderId',
  reviewerProfileId: 'joeyReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Joey! This will really help me!',
  profileReviewedFirstName: 'Rachel',
}